// Whether the person is still on the page the site was loaded (or reloaded)
// on. The whole page slides up on load (.app-main in index.css), so pages
// with their own slide-up only play it after moving within the site;
// otherwise both would play at once on a reload.
export const navState = { firstPage: true };

export function markNavigated() {
  navState.firstPage = false;
}
